import { getMarkingCard } from '../markingCard/getMarkingCard';

export const getMarkingCards = (data) => {
  const cardsToRender = data.map((cargo) => getMarkingCard(cargo));
  return cardsToRender.join('');
};
